module.exports = __webpack_public_path__ + "img/block_bg_3.c4b88fbb.webp";